const SignIn = () => <h1>Logging in...</h1>;

export default SignIn;
